import React, { useState } from "react";
import Banner from "@cs/components/src/Banner";
import Input from "@cs/components/src/Input";
import Section from "@cs/components/src/Section";
import Spinner from "@cs/components/src/Spinner";
import Table from "@cs/components/src/ThemedTable";
import Fuse from "fuse.js";
import { Search } from "react-feather";
import { styled } from "styled-components";
import { useOrganizationQuery } from "../../hooks/useOrganizationQuery";

const Wrapper = styled.div`
  width: 50%;
  margin: auto;
  padding-top: 30px;
  padding-bottom: 50px;
  max-width: 500px;
`;

const Row = styled.div`
  font-size: 16px;
  display: flex;
  align-items: center;
`;

const OrganizationList = () => {
  const { data, isLoading, isError } = useOrganizationQuery();
  const [search, setSearch] = useState("");

  let rows = data ?? [];
  if (search) {
    const fuse = new Fuse(rows, {
      keys: [
        {
          name: "label",
          getFn: (o) => (typeof o.label === "string" ? o.label : ""),
        },
        { name: "value", getFn: (o) => o.value ?? "" },
      ],
      ignoreLocation: true,
      threshold: 0.3,
      shouldSort: false,
    });
    rows = fuse.search(search).map((r) => r.item);
  }

  return (
    <Wrapper>
      <Section title="Choose an Organization">
        <Input
          value={search}
          onChange={setSearch}
          placeholder="Search"
          icon={Search}
          clearable
        />
        {isLoading ? (
          <Spinner />
        ) : isError ? (
          <Banner error="Error loading organizations" />
        ) : (
          <Table
            rows={rows.map(({ label, value }) => ({
              element: () => <Row>{label}</Row>,
              id: value ?? "",
              link: `../dashboard/${value}/plugin`,
            }))}
            autoHeight={{}}
          />
        )}
      </Section>
    </Wrapper>
  );
};

export default OrganizationList;
